<template>
  <div class="expert-callback" :class="isExpertOnline ? 'online' : 'offline'">
    <div class="expert-callback__image">
    </div>
    <div class="expert-callback__body">
      <div class="expert-callback__text-wrap">
        <p class="expert-callback__title">
          {{ $t('expert_block.title') }}
        </p>
        <p v-if="isExpertOnline" class="expert-callback__text">
          {{ $t('expert_block.text_online') }}
        </p>
        <p v-else class="expert-callback__text"  v-html="$t('expert_block.text_offline', technicalExpertWorkingHours)">
        </p>
      </div>
      <!--      <button v-if="false" class="expert-callback__btn">-->
      <!--        Перезвоните мне-->
      <!--      </button>-->
      <div class="expert-callback__form">
        <ProductCallbackForm :is-technical-expert="true" :product-id="productId"/>
      </div>
    </div>

  </div>
</template>
<script>
import ProductCallbackForm from '@/components/product/product-page/callback/ProductCallbackForm'
import dateTimeHelper from '@/helpers/dateTimeHelpers'
import { mapState } from 'vuex'

export default {
  name: 'ExpertCallback',
  components: {
    ProductCallbackForm
  },
  data () {
    return {
      kyivTime: dateTimeHelper.getTimeInTimezone()
    }
  },
  props: {
    productId: {
      type: [String, Number]
    },
    workingHours: {
      type: Object,
      validator: (val) => {
        return val.hasOwnProperty('from') && val.hasOwnProperty('to')
      },
      required: false
    }
  },
  computed: {
    ...mapState({
      isUserAuth: state => state.user.auth
    }),
    technicalExpertWorkingHours () {
      return this.workingHours || this.$store.state.productInfo.productInfo.technicalExpertWorkingHours
    },
    isExpertOnline () {
      return this.kyivTime.getHours() >= this.technicalExpertWorkingHours.from && this.kyivTime.getHours() < this.technicalExpertWorkingHours.to
    }
  },
  methods: {
    openModal () {
      this.$modal.show('quick-order-modal', { type: 'pre-order' })
    }
  },
  created () {
    setInterval(() => {
      this.kyivTime = dateTimeHelper.getTimeInTimezone()
    }, 15000)
  }
}
</script>
<style lang="sass" scoped>
.expert-callback
  background-color: #f8f8f8
  border-radius: 3px
  padding: 30px 30px 35px 30px
  margin: 30px 0
  display: flex
  flex-wrap: nowrap
  justify-content: center

.expert-callback__body
  margin-top: 10px
  width: max-content
  display: flex
  flex-wrap: wrap

.expert-callback__image
  width: 56px
  min-width: 56px
  height: 56px
  border-radius: 50%
  background-image: url('/img/expert-block__img.png')
  background-size: contain
  background-repeat: no-repeat
  background-position: center
  position: relative
  margin-right: 25px
  &::after
    content: ""
    position: absolute
    bottom: 3px
    right: 0
    width: 16px
    height: 16px
    border-radius: 50%
    border: 2px solid #EEFAEE

.expert-callback.online .expert-callback__image::after
  background-color: #359D3F

.expert-callback.offline .expert-callback__image::after
  background-color: #FF2F00

.expert-callback__text-wrap
  margin-bottom: 20px
  +mmin($tablet)
    margin-right: 20px

.expert-callback__title
  font-size: 12px
  line-height: 1.5
  color: $text-color
  font-weight: 500
  text-transform: uppercase
  margin: 0 0 5px
  max-width: 400px

.expert-callback__text
  font-size: 14px
  line-height: 18px
  color: rgba(51, 51, 51, .8)
  margin: 0
  max-width: 400px
  strong
    font-weight: 500

=form-btn
  font-size: 14px
  line-height: 18px
  color: $text-color
  text-align: center
  font-weight: 500
  min-width: 165px
  padding: 10px 20px
  background-color: #ffffff
  height: 40px
  border-radius: 3px
  border: 1px solid #e7e7e7
  align-self: center

.expert-callback__btn
  +form-btn

.expert-callback.online .expert-callback__btn
  border-color: #359D3F
  &:hover
    background-color: #359D3F
    color: #fff

.expert-callback__form
  &::v-deep
    .callback__form
      display: flex
      flex-wrap: wrap
    .callback-form__item
      max-width: 300px
      margin: 5px 0 0

    .callback-form__button
      +form-btn
      min-width: 170px
      &:not(.vue-button--disabled)
        border-color: #359D3F
        &:hover
          background-color: #359D3F
          color: #fff
    .auth-form .control-box, .control-box
      margin-right: 10px
      &.control-box--phone
        width: 100%
    .custom-phone-input
      max-width: 170px

    .callback-form__successfull-text
      text-align: left

</style>
